// Shared vocabulary for the "Request a video" quick reply. The composer toggle prefills
// REQUEST_VIDEO_MESSAGE as a convenience; the request itself travels as message metadata.
// containsVideoRequest remains only as the render fallback for pre-metadata messages.

export const REQUEST_VIDEO_MESSAGE = "Thanks for your pitch! I'd love to learn more. Can you please send me a recorded video"
  + " through Qwoted's inbox? It will help me better evaluate your story idea, and I'll be in touch"
  + ' if I need any additional information.';

// Fired by the CTA card; MessageComposer listens and opens its recorder modal.
export const OPEN_RECORDER_EVENT = 'my-inbox:open-video-recorder';

// Collapse HTML to comparable plain text so detection survives the editor re-wrapping the
// message in divs or the user typing around it.
const asComparableText = (html) => (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

// Anchors for received messages. Users personalize the prefill mid-sentence ("…a recorded video
// from Courtney through Qwoted's inbox"), so require two short fragments independently rather
// than one strict phrase; both are apostrophe-free (entity encoding breaks matching).
const VIDEO_REQUEST_ANCHORS = ['a recorded video', 'through qwoted'];

export const containsVideoRequest = (html) => {
  const text = asComparableText(html).toLowerCase();
  return VIDEO_REQUEST_ANCHORS.every((anchor) => text.includes(anchor));
};
